import axios from 'axios';
import { createSignedDeleteRequest } from 'utils/createSignedRequestsHelpers';

export default async function deleteRecord(
  projectId,
  recordId,
  activeEmployerInfo
) {
  const apiPath = `projects/${projectId}/delete-record/${recordId}`;

  const signedRequest = await createSignedDeleteRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
}
